export const ProductEnrichmentResourcesQAStatus = {
  PENDING: 'PENDING',
  READY_FOR_QA: 'READY_FOR_QA',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
};

export const ProductEnrichmentResourcesQAStatusLabels = {
  [ProductEnrichmentResourcesQAStatus.PENDING]: 'Pending',
  [ProductEnrichmentResourcesQAStatus.READY_FOR_QA]: 'Ready for QA',
  [ProductEnrichmentResourcesQAStatus.IN_PROGRESS]: 'In Progress',
  [ProductEnrichmentResourcesQAStatus.COMPLETED]: 'Completed',
  [ProductEnrichmentResourcesQAStatus.FAILED]: 'Failed',
};
